import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaya = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={21} height={20} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M10.334 18.333a7.294 7.294 0 0 1-7.292-7.291 7.294 7.294 0 0 1 7.292-7.292 7.294 7.294 0 0 1 7.291 7.292M10.334 6.667v4.166'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M7.834 1.667h5'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M16.167 14.167V17.5M13.667 14.167V17.5'
    />
  </svg>
);
export default SvgPaya;
